import { Button, Typography } from "@mui/material";
import PageWrapper from "components/PageWrapper";
import makeStyles from "@mui/styles/makeStyles";
import { analyticsTrack } from "app/analytics/track";
import { useLocation } from "react-router";
import lotusDark from "images/icons/lotus-dark-bold.svg";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import { routes } from "app/routes";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => {
    return {
        customWrapper: {
            minHeight: "70vh",
        },
        lotusIcon: {
            height: theme.spacing(15),
            width: theme.spacing(15),
            margin: "0 auto",
            display: "block",
        },
        headings: {
            textAlign: "center",
            marginTop: 0,
            marginBottom: 0,
        },
        button: {
            margin: "0 auto",
            display: "block",
            marginTop: theme.spacing(3),
        },
    };
});

export const NotFoundPage = () => {
    const classes = useStyles();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        analyticsTrack("page.not.found", {
            location: location.pathname,
            search: location.search,
            hash: location.hash,
            referrer: document.referrer,
        });
    }, [location]);

    return (
        <PageWrapper className={classes.customWrapper}>
            <img src={lotusDark} className={classes.lotusIcon} alt="LotusIcon" />
            <Typography variant="h1" className={classes.headings}>
                404
            </Typography>
            <Typography variant="h2" className={classes.headings}>
                Page not found
            </Typography>
            <Button
                variant="primary"
                className={classes.button}
                onClick={() => dispatch(push(routes.home()))}
            >
                Go to homepage
            </Button>
        </PageWrapper>
    );
};

export default NotFoundPage;
